import { styled } from "styled-components";

export const WrapperStyled = styled.div<{ $alignment: string }>`
  justify-content: ${({ $alignment }) => {
    const alignments: Record<string, string> = {
      start: "flex-start",
      center: "center",
      end: "flex-end",
    };
    return `${alignments[$alignment]}`;
  }};

  @media screen and (max-width: 768px) {
    justify-content: center;
  }
`;

export const ElementStyled = styled.div<{
  $round: string;
  $shadow: boolean;
  $shape: string;
}>`
  width: var(--entity-width);
  height: var(--entity-height);
  border-radius: ${({ $round = "0" }) => $round};
  box-shadow: ${({ $shadow }) =>
    $shadow ? "rgba(0, 0, 0, 0.15) 0 4px 8px" : "none"};
  /* Mobile: min(user resize, shape-based cap when capped [circle/square 40%, other 60%], original). When --combo-mobile-fill-cell (array 3+ per line), use 100%. Floored by --entity-mobile-min-width so stacked caps never shrink media to nothing. */
  @media screen and (max-width: 768px) {
    width: max(
      var(--entity-mobile-min-width, 40%),
      min(
        var(--entity-mobile-width-override, 100%),
        calc(
          100% * (1 - var(--combo-mobile-media-capped, 0)) +
            var(--entity-mobile-cap-by-shape, 40%) *
            var(--combo-mobile-media-capped, 0)
        ),
        calc(
          80% * (1 - var(--combo-mobile-fill-cell, 0)) + 100% *
            var(--combo-mobile-fill-cell, 0)
        )
      )
    );
  }
  @media screen and (max-width: 576px) {
    width: max(
      var(--entity-mobile-min-width, 40%),
      min(
        var(--entity-mobile-width-override, 100%),
        calc(
          100% * (1 - var(--combo-mobile-media-capped, 0)) +
            var(--entity-mobile-cap-by-shape, 40%) *
            var(--combo-mobile-media-capped, 0)
        ),
        ${({ $shape }) => `calc(
          ${["circle", "square"].includes($shape) ? "80%" : "100%"} *
            (1 - var(--combo-mobile-fill-cell, 0)) + 100% *
            var(--combo-mobile-fill-cell, 0)
        )`}
      )
    );
  }
`;
